import {
    NotificationSequenceMessage,
    NotificationSequenceMessageInstance, NotificationSequenceMessageInstanceStatus
} from "@/notification-sequences/interfaces/NotificationSequence";

const NotificationSequenceInstanceService = () => {

    /**
     * Retrieve the notification sequence message instance for the given sequence message.
     */
    const instanceForSequenceMessage = (messageInstances: NotificationSequenceMessageInstance[], message: NotificationSequenceMessage) => {
        return messageInstances.find((instance) => instance.notification_sequence_message_id === message.id);
    };

    /**
     * The status considered as successful.
     */
    const successStatus = () => {
        return [
            NotificationSequenceMessageInstanceStatus.DISPATCHED,
            NotificationSequenceMessageInstanceStatus.PENDING
        ];
    };

    /**
     * The status considered as error.
     */
    const errorStatus = () => {
        return [
            NotificationSequenceMessageInstanceStatus.FAILED,
            NotificationSequenceMessageInstanceStatus.NO_CREDIT
        ];
    };

    /**
     * The status considered as warning.
     */
    const warningStatus = () => {
        return [
            NotificationSequenceMessageInstanceStatus.NO_CUSTOMER,
            NotificationSequenceMessageInstanceStatus.NO_VALID_PHONE,
            NotificationSequenceMessageInstanceStatus.SKIPPED
        ];
    };

    return {
        instanceForSequenceMessage,
        successStatus,
        errorStatus,
        warningStatus
    };
};

export default NotificationSequenceInstanceService();
